import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {StoreModule} from '@ngrx/store';

import {
  DiagramPortService, DiagramService, DiagramUnitService, FeatureGroupTypeService,
  FeatureService, FeatureTypeService, GuiZoneService, ProjectService
} from '@catcore/services';

import {NotificationsComponent} from '@catcore/components/notifications/notifications.component';
import {NotificationsService} from '@catcore/services/notifications.service';

import {HttpClientModule} from '@angular/common/http';
import {UnitsService} from '@catcore/../models/units/services/units.service';
import {ResourceWizardComponent} from '@catcore/components/resource-wizard/resource-wizard.component';
import {ResourceComponent} from '@catcore/components/resource/resource.component';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {StatusesService} from '@catcore/services/statuses.service';
import {SvgExportService} from "@catcore/services/svg-export/svg-export.service";
import {WebApiErrorService} from '@catcore/web-api-error/services/web-api-error.service';
import {GrowlModule} from '@catmodules/widgets/growl/growl.module';
import {DataTableModule, ProgressBarModule, SidebarModule, TerminalModule} from 'primeng/primeng';
import * as reducers from './reducers';
import {DatatableExportService} from "@catcore/services/datatable-export.service";
import {UserService} from "@catcore/services/user.service";
import {UpdateService} from "@catcore/services/update.service";
import {ServerNotificationService} from "@catcore/services/server-notification.service";
import { ServerNotificationsComponent } from './components/server-notifications/server-notifications.component';
import {TerminalService} from "primeng/components/terminal/terminalservice";
import {UIBaseModule} from "@catui/ui-base.module";
import {ClientVersionService} from "@catcore/services/client-version.service";
import {ServerEventService} from "@catcore/services/server-event.service";

const publicComponents = [
  NotificationsComponent,
  ResourceWizardComponent,
  ResourceComponent,
  ServerNotificationsComponent,
  // ResourceMapComponent,
];

const imports = [
  HttpClientModule,
  GrowlModule,
  CommonModule,
  RouterModule,
  DataTableModule,
  ProgressBarModule,
  SidebarModule,
  UIBaseModule,
  TerminalModule,
  StoreModule.forFeature(
    reducers.featureName,
    {
      currentProject: reducers.currentProjectReducer,
      feature: reducers.featureReducer,
    }),

];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];
const providers = [
  ProjectService,
  NotificationsService,
  ServerNotificationService,
  ServerEventService,
  TerminalService,
  StatusesService,
  SvgExportService,
  FeatureGroupTypeService,
  FeatureTypeService,
  DiagramService,
  DiagramUnitService,
  DiagramPortService,
  DatatableExportService,
  UnitsService,
  FeatureService,
  GuiZoneService,
  EntitySchemaService,
  WebApiErrorService,
  UserService,
  UpdateService,
  ClientVersionService
];

@NgModule({
  imports,
  declarations,
  providers,
  exports: exportings,
})
export class CoreModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/core.module.ts